// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1q8VK","large":"styles_large__2TesU"};